// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { PanelMenuPresentationProps } from "@west/MobiusOverrides/PanelMenu";
import { buttonTransparent } from "@west/XDL/PreStyle/button";
import { xBaseTheme } from "@west/XDL/types";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        mergeCss: true,
        cssOverrides: {
            wrapper: css`
                &:focus > *:first-child {
                    outline: none;
                }
            `,
            menu: css`
                height: calc(100% - 80px);
                background: ${color("common.background")};
            `,
            children: css`
                ${({ displayLayer }: any) => {
                    if (displayLayer <= 0) {
                        return css`
                            z-index: 1;
                            left: 0;
                        `;
                    }
                    return css`
                        left: 100%;
                    `;
                }}
            `,
        },
        panelRowProps: {
            color: "primary",
            moreIconProps: {
                src: "ChevronRight",
                size: 12,
                color: "common.ui8",
                css: css`
                    justify-content: flex-end;
                `,
            },
        },
        backIconProps: {
            src: "ChevronLeft",
            color: "primary",
            size: 20,
        },
        backButton: {
            css: css`
                min-width: 0;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 1;
                padding: 12px 16px;

                && {
                    border-bottom: 1px solid ${color("common.border")};
                }

                ${TypographyStyle} {
                    color: ${color("common.ui6")};
                }

                ${IconWrapper} {
                    color: ${color("common.ui8")};
                    margin-right: 8px;
                    top: unset;
                }

                ${buttonTransparent}
            `,
        },
        backLabel: {
            size: 14,
        },
    } as PanelMenuPresentationProps,
} as xBaseTheme["panelMenu"];
